var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feature Icon with circle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44 25.4545V21.0909C44 20.8016 43.8851 20.5241 43.6805 20.3195C43.4759 20.1149 43.1984 20 42.9091 20H21.0909C20.8016 20 20.5241 20.1149 20.3195 20.3195C20.1149 20.5241 20 20.8016 20 21.0909V25.4545H44Z",
    fill: "#3869E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 27.6363V42.909C20 43.1983 20.1149 43.4758 20.3195 43.6804C20.5241 43.885 20.8016 43.9999 21.0909 43.9999H26.5455V27.6363H20Z",
    fill: "#C79939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.7274 43.9999H42.9092C43.1986 43.9999 43.476 43.885 43.6806 43.6804C43.8852 43.4758 44.0001 43.1983 44.0001 42.909V27.6363H28.7274V43.9999Z",
    fill: "#1C2034"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.65808c58782e2a874d0aff0a930164dd.svg";
export { ForwardRef as ReactComponent };